// extracted by mini-css-extract-plugin
module.exports = {"WorksCitedListItem":"styles-module--WorksCitedListItem--mgklO"};